// extracted by mini-css-extract-plugin
module.exports = {"label":"SearchForm_label__1zT4i","input":"SearchForm_input__1R9n4"};